import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function LegacyLayersRedirect() {
  const { projectId } = useParams();
  const location = useLocation();
  const next = new URLSearchParams(location.search);
  next.set('layers', 'true');
  next.delete('layerMode');
  return <Navigate replace to={`/projects/${projectId}?${next}`} />;
}
